import _ from 'underscore';

import BaseView from '../log-base/view';
import template from './list/template.html';
import Suggest from '../suggest/index';

export default BaseView.extend({
	template: _.template(template),

	// override
	initialize: function() {
		// create subview(s)
		this.instrumentSuggestView = new Suggest.Views.Main({
			el: '.js-instrument',
			dataUrl: '/autocomplete'
		}).render();

		// call parent
		BaseView.prototype.initialize.call(this, arguments);
	},

	/**
	 * override
	 * clear instrument field as well
	 * then call base method
	 **/
	onFormReset: function(e) {
		// clear suggest
		this.instrumentSuggestView.clear();

		// call base method
		BaseView.prototype.onFormReset.apply(this, [e]);
	}
});

